export default __webpack_public_path__ + "static/form-banner-desk-3068c817e60ad5d84b82ff2003bd219a.png";